import { Outlet } from 'react-router-dom'
import './Section.css'
import './SupplierManager/SupplierActions.css'

function SupplierManager() {
  return (
    <div className="dashboard-section">
      <Outlet />
    </div>
  )
}

export default SupplierManager
